var map = {
	"./1.jpg": "026b",
	"./2.jpg": "5154",
	"./3.jpg": "0f8d",
	"./4.jpg": "b619",
	"./contentbackgound.png": "98e5",
	"./g1.png": "f79d",
	"./g2.png": "2c2a",
	"./g3.png": "103f",
	"./left.png": "8f27",
	"./q1.png": "f771",
	"./q2.png": "8579",
	"./q3.png": "7a90",
	"./right.png": "602e",
	"./s1.png": "1152",
	"./s2.png": "a4ce",
	"./s3.png": "33a6",
	"./t1.png": "d527",
	"./t2.png": "5ac9",
	"./t3.png": "2cf5",
	"./xpicture.png": "4031",
	"./ypicture.png": "9715"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e8f";